import fetchCurrentAccount from "PFCore/services/accounts/current_account";

export const CURRENT_ACCOUNT_ACTIONS = {
  CURRENT_ACCOUNT_READY: "CURRENT_ACCOUNT_READY",
  CURRENT_ACCOUNT_UPDATE_LOGO: "CURRENT_ACCOUNT_UPDATE_LOGO"
};

export const currentAccountReducer = (state, { type, payload }) => {
  switch (type) {
    case CURRENT_ACCOUNT_ACTIONS.CURRENT_ACCOUNT_READY:
      return {
        ...state,
        currentAccount: payload
      };

    case CURRENT_ACCOUNT_ACTIONS.CURRENT_ACCOUNT_UPDATE_LOGO: {
      const account = state.currentAccount;
      account.logo = payload || { thumbnail_url: null, full_url: null };

      return {
        ...state,
        currentAccount: account
      };
    }
  }
};

export const CURRENT_ACCOUNT_ASYNC_ACTIONS = {
  CURRENT_ACCOUNT_FETCH: "CURRENT_ACCOUNT_FETCH"
};

export const currentAccountDispatch = (dispatch, action) => {
  switch (action.type) {
    case CURRENT_ACCOUNT_ASYNC_ACTIONS.CURRENT_ACCOUNT_FETCH:
      fetchCurrentAccount().then((currentAccount) => {
        dispatch({
          type: CURRENT_ACCOUNT_ACTIONS.CURRENT_ACCOUNT_READY,
          payload: currentAccount
        });
      });
      break;
  }
};
